import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("pdfConstructor", {
    openPdfConstructor: 'Открыть конструктор PDF',
    lines: 'Список',
    tiles: 'Плитка',
    grid: 'Сетка',
    horizontal: 'Горизонтальная',
    vertical: 'Вертикальная',
});
